module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/118-malasya-8b83d5aa80fb4776d7918e7f7f75bb9f.svg";